import i18n from "@/i18n";

const EVENT_NAME = "navigation_click";

interface INavigationClickEventPayload {
  label: string;
  place: string;
}

function navigationClickEvent({ label, place }: INavigationClickEventPayload) {
  window.gtag?.("event", EVENT_NAME, {
    site_language: i18n.language.toUpperCase(),
    place,
    menu_block: label,
  });

  window.rdt?.("track", "Custom", { customEventName: EVENT_NAME });
}

export default navigationClickEvent;
